import { GET_I_BOOKING } from "./actions.type";
import { ibooking } from "@/service/ibooking";

function initState() {
    return {}
}

const state = initState();

const actions = {
    async [GET_I_BOOKING](_, projectId) {
        const response = await ibooking.getIBooking(projectId);
        return response;
    }
};

const mutations = {};
const getters = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
